import React from 'react'

import SignUpBusinessForm from 'app/components/forms/Auth/SignUpBusinessForm'

const SignUpBusinessFeature: RFC = () => {
  return <SignUpBusinessForm />
}

export default SignUpBusinessFeature
